import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import TermsAndConditions from '@pages/terms/TermsAndConditions'
import WishlistPage from '@pages/wishlist/WishlistPage'
import ProductPage from '@pages/product/ProductPage'
import ContactPage from '@pages/contact/ContactPage'
import BookingPage from '@pages/booking/BookingPage'
import OfferPage from '@pages/offert/OfferPage'
import AdminPanel from '@components/AdminPanel'
import ShopPage from '@pages/shop/ShopPage'
import CartPage from '@pages/cart/CartPage'
import Login from '@pages/login/Login'
import Home from '@components/Page'

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/tienda' element={<ShopPage />} />
        <Route path='/admin' element={<AdminPanel />} />
        <Route path='/carrito' element={<CartPage />} />
        <Route path='/ofertas' element={<OfferPage />} />
        <Route path='/contacto' element={<ContactPage />} />
        <Route path='/reservas' element={<BookingPage />} />
        <Route path='/producto/:id' element={<ProductPage />} />
        <Route path='/lista-de-deseos' element={<WishlistPage />} />
        <Route path='/terminos-y-condiciones' element={<TermsAndConditions />} />

        <Route path='*' element={<Navigate to='/' />}/>
      </Routes>
    </Router>
  )
}

export default AppRoutes
